import React from 'react';
import styles from './giftInfo.module.css';
import { useLocale } from '../../../../context/LocaleContext';

export function GiftInfo({
  type,
  title,
  text,
  stamp_label,
  price,
  onEdit,
  additionalCosts = /** @type {Array<{label: string, amount: number}>} */ ([])
}) {
  const { formatPrice } = useLocale();

  return (
    <div className={styles.card}>
      <div className={styles.left}>{type}</div>
      <div className={styles.middle}>
        <div className={styles.row}>{title && <span className={styles.main}>{title}</span>}</div>
        <div className={styles.row}>{text && <span className={styles.main}>{text}</span>}</div>
        {stamp_label && <span className={styles.stamp}>Stamp: {stamp_label}</span>}

        {/* Display additional costs as notes under the parent item */}
        {additionalCosts && additionalCosts.length > 0 && (
          <div className={styles.additionalCosts}>
            {additionalCosts.map((cost, index) => (
              <div key={index} className={styles.additionalCostItem}>
                <span className={styles.additionalCostLabel}>{cost.label}:</span>
                <span className={styles.additionalCostPrice}>+ {formatPrice({ amount: cost.amount })}</span>
              </div>
            ))}
          </div>
        )}

        <div className={styles.row}>
          {price != null && <span className={styles.price}>+ {formatPrice({ amount: Number(price) })}</span>}
        </div>
      </div>
      <div className={styles.right}>
        {onEdit && (
          <button type="button" className={styles.editButton} aria-label={`Edit ${title}`} onClick={onEdit}>
            ✎
          </button>
        )}
      </div>
    </div>
  );
}
